/**
 * TabsLayout.tsx - Tabs Layout for SectionNav
 * 
 * CHANGE HISTORY:
 * - 251115_1809 [current] danielbeer: Created tabs layout
 */

import React from 'react';
import type { SectionLayoutProps } from '../types';

export const TabsLayout: React.FC<SectionLayoutProps> = ({
  sections,
  activeSection,
  onSectionClick
}) => {
  const activeContent = sections.find(s => s.id === activeSection);
  
  return (
    <div className="section-nav-tabs">
      {/* Tab headers */}
      <div className="tabs-header" role="tablist">
        {sections.map((section) => (
          <button
            key={section.id}
            className={`tab ${activeSection === section.id ? 'tab--active' : ''} ${section.disabled ? 'tab--disabled' : ''}`}
            onClick={() => !section.disabled && onSectionClick(section)}
            disabled={section.disabled}
            role="tab"
            aria-selected={activeSection === section.id}
            aria-controls={`tabpanel-${section.id}`}
            id={`tab-${section.id}`}
          >
            {section.icon && (
              <span className="tab__icon" aria-hidden="true">
                {section.icon}
              </span>
            )}
            <span className="tab__label">{section.label}</span>
            {section.badge && (
              <span className="tab__badge" aria-label={`${section.badge} notifications`}>
                {section.badge}
              </span>
            )}
          </button>
        ))}
      </div>
      
      {/* Tab content */}
      {activeContent && (
        <div
          className="tabs-content"
          role="tabpanel"
          id={`tabpanel-${activeContent.id}`}
          aria-labelledby={`tab-${activeContent.id}`}
        >
          {activeContent.component || (
            <div className="tabs-content__placeholder">
              <h3>{activeContent.label}</h3>
              {activeContent.description && <p>{activeContent.description}</p>}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

TabsLayout.displayName = 'TabsLayout';
